export const calculatePopupPosition = (index, containerWidth, space) => {
  return ((index + 1) * containerWidth) + (index * space);
};
